import { CURRENT_CONDITIONS_URL, LOCATION_URL, MAX_RANK } from './constants';

export const locationCache = new Map();
export const ccCache = new Map();

// Since on desktop, the Entity first renders hidden in the Mainline,
// and only then JS decides it should be shown in the sidebar instead,
// we sadly end up sending the location+current conditions requests twice.
// To get around this, this function will cache a promise returned by `requestFunction`
// and returned the cached promise if called again. Since we assume only 1 Entity
// per page, this should be sufficient.
const cachedRequest = (cache, requestFunction) => (options) => {
  const cacheKey = Object.values(options).join();
  if (cache.has(cacheKey)) {
    return cache.get(cacheKey);
  }

  const promise = requestFunction(options);
  cache.set(cacheKey, promise);
  return promise;
};

export const getLocation = cachedRequest(locationCache, async ({ name, locale }) => {
  const url = new URL(LOCATION_URL);
  url.searchParams.set('q', name);
  url.searchParams.set('language', locale);

  const response = await fetch(url.toString());
  const location = await response.json();
  if (location?.Rank < MAX_RANK) {
    return location;
  }

  return null;
});

export const getCurrentConditions = cachedRequest(ccCache, async ({ location, locale, metric }) => {
  const url = new URL(CURRENT_CONDITIONS_URL);
  url.searchParams.set('location', location);
  url.searchParams.set('language', locale);
  url.searchParams.set('metric', `${metric}`);

  const response = await fetch(url.toString());
  const conditions = await response.json();
  if (Array.isArray(conditions) && conditions.length > 0) {
    return conditions[0];
  }

  return null;
});
